module.exports = __webpack_public_path__ + "static/media/HO.c4441651.svg";